import { useEffect, useRef } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { SettingsProvider } from "@/lib/settings";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MobileBar from "@/components/MobileBar";
import Home from "@/pages/Home";
import FirstVisit from "@/pages/FirstVisit";
import About from "@/pages/About";
import Beliefs from "@/pages/Beliefs";
import Agenda from "@/pages/Agenda";
import Sermons from "@/pages/Sermons";
import Recaps from "@/pages/Recaps";
import Prayer from "@/pages/Prayer";
import Testimonials from "@/pages/Testimonials";
import Giving from "@/pages/Giving";
import Contact from "@/pages/Contact";
import Legal from "@/pages/Legal";
import AdminLogin from "@/pages/admin/AdminLogin";
import Admin from "@/pages/admin/Admin";

let lenisRef = null;

function ScrollManager() {
  const { pathname } = useLocation();
  useEffect(() => {
    if (lenisRef) lenisRef.scrollTo(0, { immediate: true });
    else window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function LenisRoot({ children }) {
  const rafRef = useRef(null);
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    lenisRef = lenis;
    const raf = (t) => {
      lenis.raf(t);
      rafRef.current = requestAnimationFrame(raf);
    };
    rafRef.current = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafRef.current);
      lenis.destroy();
      lenisRef = null;
    };
  }, []);
  return children;
}

function Layout() {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="min-h-screen bg-cream">
      <ScrollManager />
      {!isAdmin && <Navbar />}
      <main className={isAdmin ? "" : "pb-20 md:pb-0"}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/premiere-visite" element={<FirstVisit />} />
          <Route path="/qui-sommes-nous" element={<About />} />
          <Route path="/ce-que-nous-croyons" element={<Beliefs />} />
          <Route path="/agenda" element={<Agenda />} />
          <Route path="/predications" element={<Sermons />} />
          <Route path="/recaps" element={<Recaps />} />
          <Route path="/priere" element={<Prayer />} />
          <Route path="/temoignages" element={<Testimonials />} />
          <Route path="/donner" element={<Giving />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/mentions-legales" element={<Legal kind="mentions" />} />
          <Route path="/politique-de-confidentialite" element={<Legal kind="privacy" />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<Admin />} />
          <Route path="*" element={<Home />} />
        </Routes>
      </main>
      {!isAdmin && <Footer />}
      {!isAdmin && <MobileBar />}
    </div>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <SettingsProvider>
        <LenisRoot>
          <Layout />
          <Toaster position="top-center" richColors toastOptions={{ style: { borderRadius: "14px" } }} />
        </LenisRoot>
      </SettingsProvider>
    </BrowserRouter>
  );
}
